import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { bookTOC, PageNode } from "../../data/bookTOC";
import "./TableOfContents.css";

const TableOfContents: React.FC = () => {
  // Get the current location (URL)
  const location = useLocation();

  // Function to check if the link is active based on the current location
  const isActiveLink = (slug: string) => {
    return location.pathname.startsWith(`/${slug}`);
  };

  return (
    <nav className="toc">
      <ul className="chapter-list">
        {bookTOC.map((chapter: PageNode) => {
          // Determine if this chapter is active by checking if its path matches the current location
          const isChapterActive = isActiveLink(chapter.slug);

          return (
            <li key={chapter.slug} className="chapter-item">
              <NavLink
                to={`/${chapter.slug}`}
                className={({ isActive }) =>
                  isActive ? "chapter-link active" : "chapter-link"
                }
                end
              >
                {chapter.title}
              </NavLink>
              {isChapterActive && chapter.subchapters && (
                <ul className="subchapter-list">
                  {chapter.subchapters.map((sub) => {
                    // Check if the subchapter is active based on the current URL
                    const isSubchapterActive = location.pathname === `/${chapter.slug}/${sub.slug}`;
                    return (
                      <li key={sub.slug} className="subchapter-item">
                        <NavLink
                          to={`/${chapter.slug}/${sub.slug}`}
                          className={({ isActive }) =>
                            isActive ? "subchapter-link active" : "subchapter-link"
                          }
                        >
                          {sub.title}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default TableOfContents;
